import { TmBaseError } from '@/core/error/tmBaseError'

export class TmFilterError extends TmBaseError {
  public name = 'TmFilterError'
}
